import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { TitleLockup } from "@vds3/type-lockups";
import styled from "styled-components";
import { Button, TextLink } from "@vds/buttons";
import { Grid, Row, Col } from "@vds/grids";
import { Input } from "@vds/inputs";
import { Notification } from "@vds/notifications";
import { DropdownSelect } from "@vds/selects";
import { Body, Title } from "@vds/typography";
import * as SiteAnalytics from "../../sitecatalyst";
import SpinnerComponent from "../../common/components/Spinner/Spinner";
import { addToCart } from 'pages/Mobility/ducks/MobilitySlice';
import MapQStreetAddress from "../Checkout/components/ShippingInfo/components/MapQStreetAdress";
import {
  MarginSpacerL,
  MarginSpacerXL,
} from "../Checkout/components/Common/styleTag";
import { reset4GState, setSaveCartLteAvailble, setCheckAvailabilityRedirection } from "pages/Landing4G/ducks/4GSlice";
import { reset5GState } from "pages/Landing5G/ducks/5GSlice";
import { postClearCart } from "pages/Checkout/ducks/CheckoutSlice";
import {
  getFixedWirelessCoverageCheck,
  postLoopQualAddress,
  postLQUnitLookup,
  postLQFiosQualification,
  setAddress,
  setAddressId,
  setFlow,
  setIsFios,
  setUnavailableService,
  clear4g5gCart,
  setSavedCartZipCode,
  setSavedCart,
  setSavedCartStreet,
  setSavedCartState,
  setSavedCartCity,
  getLQSessionDetails,
  setUnit
} from "./ducks/QualificationSlice";
import { getRetrieveCart5G } from "../Checkout/ducks/CheckoutSlice";
import * as CheckoutSlice from "../Checkout/ducks/CheckoutSlice";
import "./Qualification.css";
import { ChatLink } from "common/components";
import SEOTagger from "common/components/SEOTagger/SEOTagger";
import { isCartHaveUncappedPlan } from "pages/ShoppingCart/util";
import { lqData } from "pages/Checkout/ducks/selectors";
import MapQUnit from "pages/Checkout/components/ShippingInfo/components/MapQUnit";
import { checkIfAemExists } from "utils/commonUtils";

const StyledMapSection = styled.div`
  padding: 30px 0;
`;

function Qualification(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const globalData = useSelector((state) => state.GlobalData);
  const iswirelessplusBI = globalData?.isWirelessToFwaFlow ? true : false;

  const pageData = useSelector((state) => state.LQPage);
  const unifiedCartParams = useSelector(
    (state) => state.CheckoutPage?.unifiedCartParams
  );
  const redirectTo4gPostAddressValidation = useSelector(
    (state) => state.CheckoutPage?.redirectTo4gPostAddressValidation
  );
  const redirectTo5gPostAddressValidation = useSelector(
    (state) => state.CheckoutPage?.redirectTo5gPostAddressValidation
  );
  const hasCbandPresent = useSelector(
    (state) => state.CheckoutPage?.hasCbandPresent
  );
  const isIntcmpLearn = useSelector((state) => state.Landing4GPage.isIntcmpLearn);
  const checkVisaOffer = useSelector((state) => state.CheckoutPage.isShowVisaOffer);
  const sessionCartData =
    globalData?.sessionCartData?.apiResponse?.prospectFlowData;
  const { t } = useTranslation(["app", "4G-5G"]);
  const aemContent = t("4G-5G", { ns: "4G-5G", returnObjects: true });
  const loadUnit = checkIfAemExists(t("loadUnit", { ns: "app" }))
  const checkAvailabilityContentObj = aemContent?.loopQual?.checkAvailability;
  const [errorMessages, setErrorMessages] = useState({});
  const [contentObj, setContentObj] = useState(aemContent.loopQual.landing);
  const checkAvailabilityContent = aemContent?.loopQual?.checkAvailability;
  const [units, setUnits] = useState({});
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [unitsAvailable, setUnitsAvailable] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const isDigitalQuote = sessionCartData?.cart?.digitalQuote || window.sessionStorage.getItem("isDigitalQuote");
  const [emailAddress, setEmailAddress] = useState("");
  const { isAddressConfirmationModal, onClose, isRetrieveCart, addressForSaveCart, checkAvailability = false } = props;
  const [prospectAddress, setProspectAddress] = useState(addressForSaveCart || "");
  const [continueText, setContinueText] = useState(false);
  const BBALQResp = useSelector((state) => state.LQPage?.BBALQResp);
  const showUnitInQualification = checkIfAemExists(t("showUnitInQualification", { ns: "app" }))
  const ENABLE_FIXEDWIRELESS_LOOPQUAL = aemContent?.enableFixedWirelessLoopQaul || false;
  const lqsessionId = window.sessionStorage.getItem("lqsessionIdNew") || '';
  const newPricePlanCode = window.sessionStorage.getItem("newPricePlanCode") || '';
  const addressUnit = pageData?.unit?.unit ?? sessionCartData?.prospect5gLoopQualAddress?.addressLine2;

  const isLoading = pageData?.loading;
  const address = pageData?.address;
  const zip = pageData?.address?.place?.properties?.postalCode?.split("-");

  const isMobile = useMediaQuery({
    query: "(max-width: 544px)",
  });

  useEffect(() => {
    dispatch(setFlow(unifiedCartParams?.flow || "5g"));
    dispatch(setIsFios(false));
    dispatch(setUnavailableService(""));
    dispatch(setAddress(""));
    const req = {
      digitalQuote: !!unifiedCartParams?.quoteId,
      flow: unifiedCartParams?.flow || "5g",
    };

  }, []);

  useEffect(() => {
    if (BBALQResp && Object.keys(BBALQResp)?.length > 0 && ENABLE_FIXEDWIRELESS_LOOPQUAL && !checkAvailability && !prospectAddress) {
      let cartPackages = sessionCartData?.cart?.packages;
      let packageIds = cartPackages ? Object.keys(cartPackages) : [];
      if (packageIds?.length > 0) {
        for (let pkg in packageIds) {
          if (cartPackages[packageIds[pkg]]?.packageType === "FOURG" || cartPackages[packageIds[pkg]]?.packageType === "FIVEG") {
            dispatch(reset4GState());
            dispatch(reset5GState());
            dispatch(CheckoutSlice.packageRemoveFourGorFiveG());
            break;
          }
        }
      }
      if (BBALQResp?.fiosQualified) {
        if (globalData?.fromAgentLinkDealsPage) {
          window.open(BBALQResp?.broadBandRedirectUrl, "_self")
        } else {
          addFiosAddress();
          navigate("/shop/solutions/5g/fios-option");
          sessionStorage.setItem("fiosURL", BBALQResp?.broadBandRedirectUrl)
        }
      } else if (BBALQResp?.qualified5GHome || BBALQResp?.qualified5GCband || BBALQResp?.qualifiedTW) {
        navigate("/shop/solutions/5g/plans");
      } else {
        navigate("/shop/products/networks/connectivity/lte-business-internet/plans");
      }

    } else if (BBALQResp && Object.keys(BBALQResp)?.length > 0 && ENABLE_FIXEDWIRELESS_LOOPQUAL && checkAvailability && !prospectAddress) {

      if (checkAvailability) dispatch(setCheckAvailabilityRedirection(true))
      if (BBALQResp?.qualified5GHome || BBALQResp?.qualified5GCband) {
        navigate("/shop/solutions/5g/plans");
      } else {
        navigate("/shop/products/networks/connectivity/lte-business-internet/plans");
      }
    } else if (BBALQResp && Object.keys(BBALQResp)?.length > 0 && ENABLE_FIXEDWIRELESS_LOOPQUAL && prospectAddress) {
      if (BBALQResp?.availableCapacity && Number(BBALQResp?.availableCapacity) === 0) {
        if ((BBALQResp?.mwwCart === true || BBALQResp?.qualifiedTW === true) && isAddressConfirmationModal) {
          navigate("/shop/checkout");
        }
        else {
          dispatch(CheckoutSlice.packageRemove());
          dispatch(setSaveCartLteAvailble(true));
          navigate("/shop/products/networks/connectivity/lte-business-internet/plans");
        }
      } else {
        onClose && onClose();
      }
    }
  }, [BBALQResp])

  // set appropriate content for the flow (5G/Fios)
  useEffect(() => {
    if (pageData?.isFios) {
      setContentObj(aemContent.loopQual.fios);
    } else {
      setContentObj(aemContent.loopQual.landing);
    }
  }, [pageData?.isFios]);

  // populate link content from AEM object
  const getLinks = useCallback(() => {
    const linkKeys = Object.keys(contentObj).filter((key) =>
      key.startsWith("link")
    );
    const linkArr = [];
    for (const key of linkKeys) {
      const link = contentObj[key];
      linkArr.push(
        <>
          <TextLink type="standAlone" href={link.href}>
            {link.label}
          </TextLink>
          <MarginSpacerL />
        </>
      );
    }
    return linkArr;
  }, [contentObj]);

  useEffect(() => {
    if (redirectTo4gPostAddressValidation) {
      window.sessionStorage.setItem("5g-Qual", "no");
      navigate(
        "/shop/products/networks/connectivity/lte-business-internet/plans"
      );
    }
  }, [redirectTo4gPostAddressValidation]);
  useEffect(() => {
    if (redirectTo5gPostAddressValidation) {
      window.sessionStorage.setItem("5g-Qual", "no");
      dispatch(reset5GState());
      dispatch(postClearCart());
      navigate("/shop/solutions/5g/plans");
    }
  }, [redirectTo5gPostAddressValidation]);

  useEffect(() => {

    if ((pageData?.loopQualAddressResponse && pageData?.loopQualAddressResponse?.status)) {
      if ((pageData?.loopQualAddressResponse?.status?.success) || ( pageData?.fixedWirelessResponse?.serviceStatus?.success)) {
        // TODO: redirect logic for upper funnel
        if ((unifiedCartParams?.quoteId || isDigitalQuote || isRetrieveCart) && isAddressConfirmationModal) {
          if (isCartHaveUncappedPlan(sessionCartData?.cart?.packages) && pageData?.fixedWirelessResponse?.response?.qualified4GHome) {
            onClose && onClose();
          } else if (isCartHaveUncappedPlan(sessionCartData?.cart?.packages) && !pageData?.fixedWirelessResponse?.response?.qualified4GHome) {
            let cartPackages = sessionCartData?.cart?.packages;
            let deviceId;
            let packageIds = Object.keys(cartPackages);
            for (let pkg in packageIds) {
              if (cartPackages[packageIds[pkg]]?.packageType === "FOURG") {
                deviceId = packageIds[pkg];
              }
            }
            const payload = {
              cartMeta: {
                zipCode: "",
                shoppingPath: "prospect",
              },

              lines: [
                {
                  packageId: deviceId,
                  packageType: "FOURG",
                  operation: "DELETE",
                },
              ],
            };
            dispatch(addToCart(payload));
            if (pageData?.fixedWirelessResponse?.response?.qualified5GHome ||
              pageData?.fixedWirelessResponse?.response?.response?.qualified5GCband) {
              navigate("/shop/solutions/5g/plans");
            } else {
              navigate("/shop/products/networks/connectivity/lte-business-internet/plans");
            }
          } else if (((!pageData?.fixedWirelessResponse?.response?.qualified5GHome && !pageData?.fixedWirelessResponse?.response?.qualified5GCband) || Number(pageData?.fixedWirelessResponse?.response?.availableCapacity) == 0)) {
            dispatch(CheckoutSlice.packageRemove());
            dispatch(setSaveCartLteAvailble(true));
            navigate("/shop/products/networks/connectivity/lte-business-internet/plans");
          }
          else if (pageData?.flow === "4g" && !isCartHaveUncappedPlan(sessionCartData?.cart?.packages)) {
            dispatch(CheckoutSlice.packageRemove());
          } else if (!isDigitalQuote && !isRetrieveCart && pageData?.flow === "5g" && pageData?.mmw === true && pageData?.cband === false && hasCbandPresent === true) {
            dispatch(CheckoutSlice.packageRemoveCband());
          }
          else {
            onClose && onClose();
          }
        } else {
          if (pageData?.flow === "5g") {
            if (pageData?.mmw === true && checkAvailability) {
              navigate("/shop/shopping-cart");
            }
            else if (aemContent?.fiveG?.skipLandingPage) {
              navigate("/shop/solutions/5g/plans")
            } else {
              navigate("/shop/solutions/5g/landing");
            }
          } else {
            if (aemContent?.fourG?.skipLandingPage) {
              if (checkAvailability) dispatch(setCheckAvailabilityRedirection(true))
              navigate(
                "/shop/products/networks/connectivity/lte-business-internet/plans"
              );
            } else {
              navigate(
                "/shop/products/networks/connectivity/lte-business-internet/landing"
              );
            }
          }
        }
      } else {
        dispatch(
          CheckoutSlice.setSuspendScenario(
            pageData?.loopQualAddressResponse?.status?.statusCode
          )
        );
        SiteAnalytics.contactUsLanding();
        navigate("/shop/contact-us", { state: { refUrl: window.location.pathname } });
      }
    }
  }, [pageData?.loopQualAddressResponse]);

  // on streetLookup response
  useEffect(() => {
    const resp = pageData?.streetLookupResponse;
    if (resp?.data?.length > 0) {
      dispatch(setAddressId(resp.data[0]?.addressID));
      const req = {
        addressId: resp.data[0]?.addressID,
        street: pageData?.address?.place?.properties?.street,
        state: pageData?.address?.place?.properties?.stateCode,
        zip: zip?.length > 0 ? zip[0] : zip,
      };
      dispatch(postLQUnitLookup(req));
    }
  }, [pageData?.streetLookupResponse]);

  useEffect(() => {
    if (!!isAddressConfirmationModal && !!addressForSaveCart && addressForSaveCart?.length > 0) {
      setContinueText(true);
      setProspectAddress(addressForSaveCart);
      dispatch(setSavedCart(true))
      dispatch(setSavedCartStreet(sessionCartData?.prospect5gLoopQualAddress?.addressLine1))
      dispatch(setSavedCartCity(sessionCartData?.prospect5gLoopQualAddress?.city))
      dispatch(setSavedCartState(sessionCartData?.prospect5gLoopQualAddress?.state))
      dispatch(setSavedCartZipCode(sessionCartData?.prospect5gLoopQualAddress?.zipCode))
    }
  }, [])

  // on unitLookup response
  useEffect(() => {
    const resp = pageData?.unitLookupResponse;
    const unitMap = {};
    if (resp?.data?.unitDetails?.length > 0) {
      for (const unit of resp?.data?.unitDetails) {
        unitMap[unit.addressId] = unit;
      }
    }
    setSelectedUnit(null);
    setUnits(unitMap);
  }, [pageData?.unitLookupResponse]);

  // on submitFiosQualification response
  useEffect(() => {
    if (Object.keys(pageData?.fiosQualResponse)?.length) {
      if (pageData?.fiosQualResponse?.fiosQualified === "Y") {
        addFiosAddress();
        navigate("/shop/solutions/5g/fios-option");
      } else {
        dispatch(setFlow("4g"));
        window.sessionStorage.setItem("fivegTofourg", "true");
        callLoopQualAddress("4g");
      }
    }
  }, [pageData?.fiosQualResponse]);

  // on unavailableService redux change
  useEffect(() => {
    if (
      pageData?.unavailableService &&
      Object.keys(pageData?.streetLookupResponse).length
    ) {
      if (pageData?.flow === "5g") {
        if (aemContent?.fiveG?.skipLandingPage) {
          navigate("/shop/solutions/5g/plans")
        } else {
          navigate("/shop/solutions/5g/landing");
        }
      } else {
        if (aemContent?.fourG?.skipLandingPage) {
          navigate(
            "/shop/products/networks/connectivity/lte-business-internet/plans"
          );
        } else {
          navigate(
            "/shop/products/networks/connectivity/lte-business-internet/landing"
          );
        }
      }
    }
  }, [pageData?.unavailableService]);

  useEffect(() => {
    window.sessionStorage.setItem("_flowName", "Unified");
    SiteAnalytics.loopQual();
  }, []);

  // call fixedWirelessCheck for savedcart  API
  const callFixedWirelessChecksavedCart = (fromStreetLookup = false) => {
    const req = {
      street: sessionCartData?.prospect5gLoopQualAddress?.addressLine1,
      city: sessionCartData?.prospect5gLoopQualAddress?.city,
      state: sessionCartData?.prospect5gLoopQualAddress?.state,
      zipCode: sessionCartData?.prospect5gLoopQualAddress?.zipCode,
      zipPlus4: sessionCartData?.prospect5gLoopQualAddres?.zipPlus4,
      fromStreetLookup: fromStreetLookup,
      fromQual: true,
    };

    dispatch(getFixedWirelessCoverageCheck(req));
  };

  // call fixedWirelessCheck API
  const callFixedWirelessCheck = (fromStreetLookup = false) => {
    if (!isDigitalQuote && !isRetrieveCart && !isIntcmpLearn && !checkAvailability) {
      dispatch(clear4g5gCart());
    }
    const req = {
      street: pageData?.address?.place?.properties?.street,
      city: pageData?.address?.place?.properties?.city,
      state: pageData?.address?.place?.properties?.stateCode,
      zipCode: zip?.length > 0 ? zip[0] : zip,
      zipPlus4: zip?.length > 1 ? zip[1] : "",
      fromStreetLookup: fromStreetLookup,
      fromQual: true,
      checkAvailability: true,
      coverageWirelessFlow: iswirelessplusBI ? true : false
    };
    dispatch(getFixedWirelessCoverageCheck(req));
  };

  // call loopQualAddress API
  const callLoopQualAddress = (newFlow = null) => {
    if (!unifiedCartParams?.quoteId && !isIntcmpLearn) {
      dispatch(clear4g5gCart());
    }
    const req = {
      flow: newFlow ?? pageData?.flow,
      street: pageData?.address?.place?.properties?.street,
      city: pageData?.address?.place?.properties?.city,
      state: pageData?.address?.place?.properties?.stateCode,
      zipCode: zip?.length > 0 ? zip[0] : zip,
      zipPlus4: zip?.length > 1 ? zip[1] : "",
      eventCorrelationId: pageData?.fixedWirelessResponse?.eventCorrelationId,
      cband: pageData?.cband,
      mmw: pageData?.mmw,
      digitalQuote: !!unifiedCartParams?.quoteId,
      fromQual: true
    };
    dispatch(postLoopQualAddress(req));
  };

  const callFiosQualification = () => {
    const unit = units[selectedUnit];
    const req = {
      addressId: pageData?.addressId,
      baseAddressId: unit?.baseAddressId ?? "0",
      street: pageData?.address?.place?.properties?.street,
      city: pageData?.address?.place?.properties?.city,
      state: pageData?.address?.place?.properties?.stateCode,
      zip: zip?.length > 0 ? zip[0] : zip,
      email: emailAddress,
      phone: phoneNumber.replace(/\D/g, ""),
    };
    dispatch(postLQFiosQualification(req));
  };

  const redirectToUri = (value) => {
    // remove unifiedCart cookie so the user will land on the angular app
    document.cookie =
      "unifiedCart=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";

    const hostname = window.location.origin;
    const path = window.mbtGlobal.reactUibasePath;
    // need to remove the 'shop/' at the beginning of the URI since it is already part of the base path
    const uri = value?.substring(5);
    const fullUrl = hostname + path + uri;
    window.history.pushState("", "", fullUrl);
    window.location.reload();
  };

  const isValidEmail = (value) => {
    const pattern =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value);
  };

  // set address in local storage for redirection to Fios
  const addFiosAddress = () => {
    const fiosAddress = {
      email: emailAddress,
      addressLine1: pageData?.address?.place?.properties?.street,
      streetNum: "",
      streetName: "",
      type: "",
      city: pageData?.address?.place?.properties?.city,
      state: pageData?.address?.place?.properties?.stateCode,
      zipCode: pageData?.address?.place?.properties?.postalCode?.split("-")[0] || "",
      country: "",
      locationCode: "",
      addressLine2: "",
      zipPlus4: pageData?.address?.place?.properties?.postalCode?.split("-")[1] || "",
      phoneNumber: phoneNumber,
      floorNumber:
        pageData?.fixedWirelessResponse?.addressLocInfo?.addressDescList
          ?.addressDesc[0]?.floor || null,
      descriptor:
        pageData?.fixedWirelessResponse?.addressLocInfo?.addressDescList
          ?.addressDesc[0]?.descriptor || null,
      launchType: pageData?.fixedWirelessResponse?.launchType || "",
      eventCorrelationId:
        pageData?.fixedWirelessResponse?.eventCorrelationId || "",
    };
    if (
      window.sessionStorage.getItem("fiosAddress") &&
      JSON.parse(window.sessionStorage.getItem("fiosAddress")).addressLine1 ===
      pageData?.address?.place?.properties?.street &&
      JSON.parse(window.sessionStorage.getItem("fiosAddress")).zipCode ===
      pageData?.address?.place?.properties?.postalCode.split("-")[0]
    ) {
      window.sessionStorage.setItem("UpdateAddress", "false");
    } else {
      window.sessionStorage.setItem("UpdateAddress", "true");
      window.sessionStorage.setItem("fiosAddress", JSON.stringify(fiosAddress));
    }
    window.sessionStorage.setItem(
      "fiosURL",
      pageData?.fiosQualResponse?.redirectUrl
    );
  };

  const handleCheckAvailabilityPhoneChange = (e) => {
    let phoneNumber = e?.target?.value;
    setPhoneNumber(phoneNumber)
    if (!phoneNumber || phoneNumber?.length !== 12) {
      setErrorMessages({ ...errorMessages, phone: true })
    } else {
      setErrorMessages({ ...errorMessages, phone: false })
    }
  }

  const handleCheckAvailabilityEmailChange = (e) => {
    let emailAddress = e?.target?.value;
    setEmailAddress(emailAddress)
    if (!emailAddress || !isValidEmail(emailAddress)) {
      setErrorMessages({ ...errorMessages, email: true })
    } else {
      setErrorMessages({ ...errorMessages, email: false })
    }
  }

  const validateFormFields = () => {
    let isValid = true;
    const errors = {};

    // if (!pageData?.address) {
    //   errors.addressInfoErr = true;
    //   isValid = false;
    // } else {
    //   errors.addressInfoErr = false;
    // }

    if (prospectAddress) {
      isValid = true;
      errors.addressInfoErr = false;
    }
    else if (!pageData?.address) {
      errors.addressInfoErr = true;
      isValid = false;
    }
    else {
      errors.addressInfoErr = false;
    }

    if (!!units && typeof units == "object" && Object.keys(units)?.length) {
      if (!selectedUnit) {
        errors.unit = true;
        isValid = false;
      } else {
        errors.unit = false;
      }
    }

    if (contentObj?.telephoneNumber || (checkAvailability && checkAvailabilityContentObj?.phoneNumber)) {
      if (!phoneNumber || phoneNumber?.length !== 12) {
        if (errors) {
          errors.phone = true;
        }
        isValid = false;
      } else {
        if (errors) {
          errors.phone = false;
        }
      }
    }

    if (contentObj?.emailAddress || (checkAvailability && checkAvailabilityContentObj?.emailAddress)) {
      if (!emailAddress || !isValidEmail(emailAddress)) {
        if (errors) {
          errors.email = true;
        }
        isValid = false;
      } else {
        if (errors) {
          errors.email = false;
        }
      }
    }

    setErrorMessages(errors);
    return isValid;
  };

  const continueClick = () => {
    if (validateFormFields() && !ENABLE_FIXEDWIRELESS_LOOPQUAL) {
      if (typeof prospectAddress === "string") {
        callFixedWirelessChecksavedCart();
        // callLoopQualAddressforsavedCart();
      }
      else if (!pageData?.isFios) {
        callFixedWirelessCheck();
      } else if (pageData?.streetLookupResponse?.data?.length) {
        callFiosQualification();
      }
      if (
        pageData?.isFios &&
        pageData?.streetLookupResponse?.data?.length === 0
      ) {
        callFixedWirelessCheck(true);
      }
      dispatch(reset4GState());
      dispatch(reset5GState());
    } else {
      let street, postalCode = ""
      if (pageData?.address?.place?.properties) {
        street = pageData?.address?.place?.properties?.street;
        postalCode = pageData?.address?.place?.properties?.postalCode;
      }
      const nonUnit = (addressUnit === "I don't see my unit" ? "I dont see my unit" : addressUnit === "I don't have a unit" ? "I dont have a unit" : addressUnit)
      const payload = {
        "ENABLE_FIXEDWIRELESS_LOOPQUAL": ENABLE_FIXEDWIRELESS_LOOPQUAL,
        "lqsessionId": "",
        "redirectedFrom": "",
        "flow": "4g",
        "clear4g5g": isAddressConfirmationModal || checkAvailability ? false : true,
        "IsDigitalAgent": showUnitInQualification,
        "address": {
          "addressLine1": pageData?.address?.place?.properties?.street || sessionCartData?.prospect5gLoopQualAddress?.addressLine1 || '',
          "city": pageData?.address?.place?.properties?.city || sessionCartData?.prospect5gLoopQualAddress?.city || '',
          "state": pageData?.address?.place?.properties?.state || sessionCartData?.prospect5gLoopQualAddress?.state || '',
          "zipCode": pageData?.address?.place?.properties?.postalCode || sessionCartData?.prospect5gLoopQualAddress?.zipCode || '',
          "zipPlus4": sessionCartData?.prospect5gLoopQualAddres?.zipPlus4 || '',
          baselocationId: pageData?.address?.place?.properties?.locusID || sessionCartData?.prospect5gLoopQualAddress?.baselocationId || "",
          sublocationId: ((pageData.unit && pageData.unit?.location_id) ? pageData.unit?.location_id : pageData?.address?.place?.properties?.locusID) || sessionCartData?.prospect5gLoopQualAddress?.sublocationId || "",
          addressId: ((pageData.unit && pageData?.unit?.ntasAddrId) ? pageData?.unit?.ntasAddrId : pageData?.unit?.addressId ? pageData?.unit?.addressId : pageData?.unit?.ntasBaseAddrId) ||
            pageData?.address?.place?.properties?.ntasAddrID || "",
          unit: nonUnit,
          baseAddressId: ((pageData.unit && pageData?.unit?.ntasBaseAddrId) ? pageData?.unit?.ntasBaseAddrId : pageData?.address?.place?.properties?.ntasAddrID) ?? ""
        },
        "additionalInfo": {
          "coveragefor4G": true,
          "coverageWirelessFlow": true,
          "showVisaOffer": checkVisaOffer || false,
          "firstName": "",
          "lastName": "",
          "locationId": "",
          "salesCode": "",
          "businessName": "",
          "userName": ""
        }
      }
      dispatch(getLQSessionDetails(payload));
      if (!prospectAddress) {
        dispatch(reset4GState());
        dispatch(reset5GState());
        //dispatch(setShowCheckAvailabiltyLink(false));
      }
    }
  };
  return (
    <>
      <SEOTagger />
      {!isAddressConfirmationModal ? (
        <div className="lq-page">
          {/* <Header pageName={"Qualification"} /> */}
          {isLoading && <SpinnerComponent />}
          {pageData?.apiError && (
            <Notification
              type="error"
              title="Something went wrong."
              subtitle="Please try again."
              fullBleed={true}
            />
          )}
          <div className="form">
            <Grid rowGutter="2rem" colGutter={true}>
              {!checkAvailability ?
                <Row>
                  <Col colSizes={{ mobile: 4, tablet: 8, desktop: 8 }}>
                    <MarginSpacerXL />
                    <Title size="XLarge">{contentObj.heading}</Title>
                  </Col>
                  {isMobile ? (
                    <></>
                  ) : (
                    <Col colSizes={{ mobile: 4, tablet: 4, desktop: 4 }}>
                      <ChatLink style={{ float: "right", paddingTop: "1rem" }} />
                    </Col>
                  )}
                </Row> : <></>}
              {checkAvailability ?
                <Row>
                  <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                    <TitleLockup
                      data={{
                        title: {
                          bold: true,
                          size: "titleLarge",
                          children: aemContent?.loopQual?.checkAvailability?.heading,
                        },
                        subtitle: {
                          size: "titleMedium",
                          children: <Body primitive="h4" size="large">{aemContent?.loopQual?.checkAvailability?.subHeading}</Body>,
                        }
                      }}
                    />
                  </Col>
                </Row> : <></>
              }
              <Row>
                <Col colSizes={checkAvailability ? { mobile: 4, tablet: 12, desktop: 12 } : { mobile: 4, tablet: 6, desktop: 6 }}>
                  <MapQStreetAddress
                    errorMessage={checkAvailability ? checkAvailabilityContentObj?.errors?.address?.required : contentObj?.errors?.address?.required}
                    label={checkAvailability ? checkAvailabilityContentObj?.address : "Service address"}
                    // label={contentObj.address}
                    helperText=""
                    onSelectionChange={(value) => {
                      dispatch(setAddress(value));
                    }}
                    handleAddressInput={() => { }}
                    isAddressEmty={false}
                    isError={errorMessages.addressInfoErr}
                    setAddressFieldError={(value) => {
                      setErrorMessages({
                        ...errorMessages,
                        addressInfoErr: value,
                      });
                    }}
                  // setAutoFocus={props.setAutoFocus}
                  // ref={businessStreetRef}
                  />
                </Col>
              </Row>
              <Row>
                {showUnitInQualification ?
                  <Col colSizes={checkAvailability ? { mobile: 4, tablet: 12, desktop: 12 } : { mobile: 4, tablet: 6, desktop: 6 }}>
                    <MapQUnit
                      label="Apt, suite, or unit"
                      locusID={address?.place?.properties?.locusID}
                      ntasAddrID={address?.place?.properties?.ntasAddrID}
                      onSelectionChange={value => {
                        setUnits(value);
                        dispatch(setUnit(value));
                      }}
                      setTotalAvailableUnits={value => {
                        if (address?.place?.properties) {
                          setUnitsAvailable(Number(value));
                        }
                      }}
                      loadUnit={loadUnit}
                    // isError={errorMessages?.addressInfoErr}
                    />
                  </Col>
                  : <></>}
              </Row>
              {contentObj?.telephoneNumber ? (
                <Row>
                  <Col colSizes={{ mobile: 4, tablet: 8, desktop: 8 }}>
                    <Input
                      type="tel"
                      label={contentObj.telephoneNumber}
                      readOnly={false}
                      required={true}
                      disabled={false}
                      error={errorMessages?.phone}
                      errorText={contentObj.errors.telephoneNumber.required}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                    // defaultValue={"1234567890"}
                    />
                  </Col>
                </Row>
              ) : (
                <></>
              )}
              {contentObj?.emailAddress ? (
                <Row>
                  <Col colSizes={{ mobile: 4, tablet: 8, desktop: 8 }}>
                    <Input
                      type="text"
                      label={contentObj.emailAddress}
                      readOnly={false}
                      required={true}
                      disabled={false}
                      error={errorMessages?.email}
                      errorText={contentObj.errors.emailAddress.required}
                      onChange={(e) => setEmailAddress(e.target.value)}
                    // defaultValue={"1234567890"}
                    />
                  </Col>
                </Row>
              ) : (
                <></>
              )}

              {checkAvailability ?
                <Row>
                  <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                    <Input
                      type="text"
                      label={checkAvailabilityContentObj?.unitNumber}
                      readOnly={false}
                      required={false}
                      disabled={false}
                      onChange={(e) => setSelectedUnit(e.target.value)}
                    />
                  </Col>
                </Row>
                : <></>
              }

              {checkAvailability ?
                <Row>
                  <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                    <Input
                      type="tel"
                      label={checkAvailabilityContentObj?.phoneNumber}
                      readOnly={false}
                      required={true}
                      disabled={false}
                      error={errorMessages?.phone}
                      errorText={checkAvailabilityContentObj.errors.phoneNumber.required}
                      onChange={handleCheckAvailabilityPhoneChange}
                    // defaultValue={"1234567890"}
                    />
                  </Col>
                </Row>
                : <></>}

              {checkAvailability ?
                <Row>
                  <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                    <Input
                      type="text"
                      label={checkAvailabilityContentObj?.emailAddress}
                      readOnly={false}
                      required={true}
                      disabled={false}
                      error={errorMessages?.email}
                      errorText={checkAvailabilityContentObj?.errors?.emailAddress?.required}
                      onChange={handleCheckAvailabilityEmailChange}
                    // defaultValue={"1234567890"}
                    />
                  </Col>
                </Row> : <></>}

              <Row>
                <Col colSizes={checkAvailability ? { mobile: 4, tablet: 12, desktop: 12 } : { mobile: 4, tablet: 8, desktop: 8 }}>
                  <MarginSpacerXL />
                  <Button disabled={checkAvailability ? false : !address} onClick={continueClick}>
                    {checkAvailability ? checkAvailabilityContentObj?.submit : contentObj?.submit}
                  </Button>
                </Col>
              </Row>
              {!checkAvailability ?
                <Row>
                  <Col colSizes={{ mobile: 4, tablet: 8, desktop: 12 }}>
                    <div className="links">{getLinks()}</div>
                  </Col>
                </Row> : <></>}
              {!contentObj?.formDisclaimer ? (
                <Row>
                  <Col colSizes={checkAvailability ? { mobile: 4, tablet: 12, desktop: 12 } : { mobile: 4, tablet: 8, desktop: 8 }}>
                    {/* <Body>{contentObj?.formDisclaimer}</Body> */}
                    <Body size="small" primitive="p">
                      <Trans
                        ns="4G-5G"
                        i18nKey={checkAvailability ? `4G-5G.loopQual.checkAvailability.footerText` : `4G-5G.CPRACopy`}
                        shouldUnescape={true}
                      >
                        <TextLink style={{ fontWeight: '600' }}
                          target='_blank' href='https://www.verizon.com/about/privacy/'
                        />
                        <TextLink style={{ fontWeight: '600' }}
                          target='_blank' href='https://www.verizon.com/about/privacy/full-privacy-policy?scrollto=index-1#acc-item-55'
                        />
                      </Trans>
                    </Body>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col colSizes={checkAvailability ? { mobile: 4, tablet: 12, desktop: 12 } : { "mobile": 4, "tablet": 8, "desktop": 8 }}>

                    <Body size="small" primitive="p">
                      <Trans
                        ns="4G-5G"
                        i18nKey={checkAvailability ? `4G-5G.loopQual.checkAvailability.footerText` : `4G-5G.CPRACopy`}
                        shouldUnescape={true}
                      >
                        <TextLink style={{ fontWeight: '600' }}
                          target='_blank' href='https://www.verizon.com/about/privacy/'
                        />
                        <TextLink style={{ fontWeight: '600' }}
                          target='_blank' href='https://www.verizon.com/about/privacy/full-privacy-policy?scrollto=index-1#acc-item-55'
                        />
                      </Trans>
                    </Body>

                  </Col>
                </Row>)
              }
              {!checkAvailability ?
                <Row>
                  <Col colSizes={{ mobile: 4, tablet: 8, desktop: 12 }}>
                    <MarginSpacerXL />
                    {sessionCartData?.cart?.cartId && (
                      <Body>Cart Id: {sessionCartData?.cart?.cartId}</Body>
                    )}
                  </Col>
                </Row> : <></>}
            </Grid>
          </div>
        </div>
      ) : (
        <div>
          {isLoading && <SpinnerComponent />}
          {!isLoading && <StyledMapSection>
            {!!prospectAddress && prospectAddress?.length > 0 ?
              <><MapQStreetAddress
                errorMessage="Address is required"
                label="Address"
                onSelectionChange={(value) => {
                  setProspectAddress(value);
                  dispatch(setAddress(value));
                }}
                handleAddressInput={() => { }}
                isAddressEmty={false}
                isError={errorMessages.addressInfoErr}
                setAddressFieldError={(value) => {
                  setErrorMessages({
                    ...errorMessages,
                    addressInfoErr: value,
                  });
                }}
                prospectAddress={prospectAddress} />
                <MapQUnit
                  label="Apt, suite, or unit"
                  locusID={address?.place?.properties?.locusID}
                  ntasAddrID={address?.place?.properties?.ntasAddrID}
                  onSelectionChange={value => {
                    setUnits(value);
                    dispatch(setUnit(value));
                  }}
                  setTotalAvailableUnits={value => {
                    if (address?.place?.properties) {
                      setUnitsAvailable(Number(value));
                    }
                  }}
                  addressUnits={addressUnit}
                /></> :
              <MapQStreetAddress
                errorMessage="Address is required"
                label="Address"
                onSelectionChange={(value) => {
                  setProspectAddress(value);
                  dispatch(setAddress(value));
                }}
                handleAddressInput={() => { }}
                isAddressEmty={false}
                isError={errorMessages.addressInfoErr}
                setAddressFieldError={(value) => {
                  setErrorMessages({
                    ...errorMessages,
                    addressInfoErr: value,
                  });
                }}
              />}
          </StyledMapSection>}
         {!isLoading &&  <Button disabled={!prospectAddress} onClick={continueClick}>
            {prospectAddress ? 'Validate address' : 'Confirm'}
          </Button>}
        </div>
      )}
    </>
  );
}

export default Qualification;
